const CellPhoneWithBtn = () => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.93417 20.5C4.95604 20.5 4.97799 20.5 5 20.5L11.0658 20.5C11.9523 20.5 12.7161 20.5001 13.3278 20.4179C13.9833 20.3297 14.6117 20.131 15.1213 19.6213C15.631 19.1117 15.8297 18.4833 15.9179 17.8278C16.0001 17.2161 16.0001 16.4523 16 15.5658V5.43416C16.0001 4.54768 16.0001 3.78386 15.9179 3.1722C15.8297 2.51669 15.631 1.88834 15.1213 1.37867C14.6117 0.869011 13.9833 0.670267 13.3278 0.582134C12.7161 0.499899 11.9523 0.499941 11.0658 0.49999H4.9342C4.0477 0.499941 3.28388 0.499899 2.67221 0.582134C2.0167 0.670267 1.38835 0.869011 0.878684 1.37867C0.369022 1.88834 0.170277 2.51669 0.0821453 3.1722C-9.01893e-05 3.78386 -4.73896e-05 4.54768 2.43991e-06 5.43417L4.8241e-06 15.5C4.8241e-06 15.522 3.63201e-06 15.544 2.43991e-06 15.5658C-4.73896e-05 16.4523 -9.01893e-05 17.2161 0.0821453 17.8278C0.170277 18.4833 0.369022 19.1117 0.878684 19.6213C1.38835 20.131 2.0167 20.3297 2.67221 20.4179C3.28387 20.5001 4.04769 20.5 4.93417 20.5ZM2.93871 18.4357C2.50497 18.3774 2.36902 18.2832 2.2929 18.2071C2.21677 18.131 2.12263 17.995 2.06431 17.5613C2.00213 17.0988 2 16.4711 2 15.5V5.5C2 4.52892 2.00213 3.9012 2.06431 3.4387C2.12263 3.00496 2.21677 2.86901 2.2929 2.79289C2.36902 2.71676 2.50497 2.62262 2.93871 2.5643C3.40122 2.50212 4.02893 2.49999 5 2.49999H11C11.9711 2.49999 12.5988 2.50212 13.0613 2.5643C13.495 2.62262 13.631 2.71676 13.7071 2.79289C13.7832 2.86901 13.8774 3.00496 13.9357 3.4387C13.9979 3.9012 14 4.52892 14 5.5V15.5C14 16.4711 13.9979 17.0988 13.9357 17.5613C13.8774 17.995 13.7832 18.131 13.7071 18.2071C13.631 18.2832 13.495 18.3774 13.0613 18.4357C12.5988 18.4979 11.9711 18.5 11 18.5H5C4.02893 18.5 3.40122 18.4979 2.93871 18.4357Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 15.5C0.25 15.0858 0.585786 14.75 1 14.75L15 14.75C15.4142 14.75 15.75 15.0858 15.75 15.5C15.75 15.9142 15.4142 16.25 15 16.25L1 16.25C0.585786 16.25 0.25 15.9142 0.25 15.5Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 17.5C6.25 17.0858 6.58579 16.75 7 16.75L9 16.75C9.41421 16.75 9.75 17.0858 9.75 17.5C9.75 17.9142 9.41421 18.25 9 18.25L7 18.25C6.58579 18.25 6.25 17.9142 6.25 17.5Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 4.5C3.25 4.08579 3.58579 3.75 4 3.75H7C7.41421 3.75 7.75 4.08579 7.75 4.5V7.5C7.75 7.91421 7.41421 8.25 7 8.25H4C3.80109 8.25 3.61032 8.17098 3.46967 8.03033C3.32902 7.88968 3.25 7.69891 3.25 7.5V4.5ZM4.75 5.25V6.75H6.25V5.25H4.75Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 4.5C8.25 4.08579 8.58579 3.75 9 3.75H12C12.4142 3.75 12.75 4.08579 12.75 4.5V7.5C12.75 7.91421 12.4142 8.25 12 8.25H9C8.80109 8.25 8.61032 8.17098 8.46967 8.03033C8.32902 7.88968 8.25 7.69891 8.25 7.5V4.5ZM9.75 5.25V6.75H11.25V5.25H9.75Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 9.5C3.25 9.08579 3.58579 8.75 4 8.75H7C7.41421 8.75 7.75 9.08579 7.75 9.5V12.5C7.75 12.9142 7.41421 13.25 7 13.25H4C3.80109 13.25 3.61032 13.171 3.46967 13.0303C3.32902 12.8897 3.25 12.6989 3.25 12.5V9.5ZM4.75 10.25V11.75H6.25V10.25H4.75Z"
        fill="#006DFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H12C12.4142 8.75 12.75 9.08579 12.75 9.5V12.5C12.75 12.9142 12.4142 13.25 12 13.25H9C8.80109 13.25 8.61032 13.171 8.46967 13.0303C8.32902 12.8897 8.25 12.6989 8.25 12.5V9.5ZM9.75 10.25V11.75H11.25V10.25H9.75Z"
        fill="#006DFF"
      />
    </svg>
  );
};
export default CellPhoneWithBtn;
